{
  "slug": "executive-function",
  "title": "Executive Function Explained",
  "description": "Goal maintenance, inhibition, shifting, planning, and monitoring—not one skill.",
  "category": "Science of testing",
  "sections": [
    {
      "heading": "Definition and role",
      "paragraphs": [
        "Goal maintenance, inhibition, shifting, planning, and monitoring—not one skill.",
        "The construct is inferred from performance across selected tasks; it is not directly observed."
      ]
    },
    {
      "heading": "Assessment",
      "paragraphs": [
        "Professional interpretation considers standardized administration, age norms, reliability, validity, and confidence intervals.",
        "Language, motor and sensory access, education, culture, fatigue, and health matter."
      ]
    },
    {
      "heading": "Limits",
      "paragraphs": [
        "No task captures the full construct. Combine results with history and real-world functioning.",
        "Online examples illustrate formats but do not reproduce secure professional materials."
      ]
    }
  ],
  "related": ["what-is-iq", "how-is-iq-measured", "iq-vs-intelligence"],
  "sources": [],
  "faqs": [],
  "summary": "Goal maintenance, inhibition, shifting, planning, and monitoring—not one skill. Content reviewed 18 July 2026."
}
